import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	padding: 0 20px;
	margin: 0 auto;
	position: relative;
	z-index: 10;

	.youtube_item {
		width: 100%;
		height: 100%;
		iframe {
			display: block;
			margin: 0 auto;
		}
	}

	.input {
		position: absolute;
		top: -1000px;
	}
	.mo-top-wrap,
	.mo-content,
	.mo-banner-wrap {
		display: none;
	}

	.flex-wrapper {
		display: flex;

		.left {
			max-width: 880px;
			width: 100%;
			border-right: 1px solid #eee;
			padding-right: 40px;
			.article-wrap {
				margin-top: 98px;
				margin-left: 2px;
				.tag-box {
					display: flex;
					gap: 20px;
					li {
						color: #e99210;
						font-size: 18px;
						font-weight: 300;
						line-height: normal;
					}
				}
				.title {
					font-size: 42px;
					font-weight: 700;
					line-height: 140%;
					margin-top: 18px;
					margin-bottom: 30px;
					padding-right: 40px;
				}
				.share-box {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-right: 40px;
					.left {
						display: flex;
						gap: 14px;
						border-right: none;

						a {
							border-radius: 12px;
							background: #f7f7f7;
							width: 36px;
							height: 36px;
							position: relative;
							cursor: pointer;
							img {
								position: absolute;
								top: 50%;
								left: 50%;
								transform: translate(-50%, -50%);
							}
						}
					}
					.right {
						margin-top: 0;
						.flex {
							display: flex;
							align-items: center;
							justify-content: end;
							white-space: nowrap;
							.user-box {
								display: flex;
								align-items: center;
								cursor: pointer;
								a {
									display: flex;
								}
								.people {
									display: flex;
									align-items: center;
									margin-right: 26px;
								}
								.alone {
									display: flex;
									align-items: center;
									gap: 10px;
								}
								.user {
									width: 20px;
									height: 20px;
									border-radius: 50%;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;
									border: 0.5px solid #eee;
									margin-left: -5px;
									/* &:nth-child(2) {
										position: relative;
										left: -5px;
									}
									&:nth-child(3) {
										position: relative;
										left: -10px;
									} */
								}
							}
							p {
								font-size: 18px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
							}
							.name {
								font-size: 18px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
								position: relative;
								display: flex;
								align-items: center;
								gap: 4px;
								img {
									width: 16px;
								}
								&::after {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -12px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.date {
								color: #999;
								font-size: 18px;
								font-weight: 400;
								line-height: 140%;
								margin-right: 0;
								position: relative;
								&::before {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -16px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
						}
					}
				}
			}
			.left-box {
				.article-box {
					margin-top: 39px;
					.article {
						width: 100%;
						height: auto;
						/* padding-bottom: 64%; */
						/* background-repeat: no-repeat;
						background-position: center;
						background-size: cover; */
						border-radius: 30px;
					}
					.content {
						margin-top: 40px;
						padding: 0 40px;

						font-size: 16px;
						font-weight: 500;
						line-height: 160%;

						video {
							width: 100%;
							height: auto;
						}
						iframe {
							width: 100%;
							height: 462px;
						}
						ul {
							list-style: initial;
							padding-left: 16px;
						}
						p {
							min-height: 22px;
							/* color: #333; */
							font-size: 16px;
							font-weight: 500;
							line-height: 160%;
							margin-bottom: 12px;
						}
						span {
							display: inline-block;
							padding-bottom: 20px;
						}
						p:empty,
						h2:empty,
						h3:empty {
							/* display: none; */
						}
						img {
							max-width: 100%;
							height: auto;
						}
						strong {
							font-weight: 700;
						}
						li > span {
							font-size: 16px;
							font-weight: 500;
							line-height: 160%;
						}
						h1 {
							display: block;
							font-size: 2em !important;
							/* margin-block-start: 0.67em; */
							/* margin-block-end: 0.67em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 12px;
						}
						h2 {
							display: block;
							font-size: 1.5em !important;
							/* margin-block-start: 0.83em; */
							/* margin-block-end: 0.83em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 20px;
						}
						h3 {
							display: block;
							font-size: 1.17em !important;
							/* margin-block-start: 1em; */
							/* margin-block-end: 1em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 20px;
						}
						h4 {
							display: block;
							font-size: 1em !important;
							/* margin-block-start: 1.33em; */
							/* margin-block-end: 1.33em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 20px;
						}
						h5 {
							display: block;
							font-size: 0.83em !important;
							/* margin-block-start: 1.67em; */
							/* margin-block-end: 1.67em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 20px;
						}
						h6 {
							display: block;
							font-size: 0.67em !important;
							/* margin-block-start: 2.33em; */
							/* margin-block-end: 2.33em; */
							/* margin-inline-start: 0px; */
							/* margin-inline-end: 0px; */
							font-weight: 500;
							margin-bottom: 20px;
						}

						.wp-block-code {
							background: #f7f7f7;
							padding: 30px;
							line-height: 20px;
							overflow-x: scroll;
						}

						a {
							color: #ffac00;
							text-decoration: underline;
						}
						figcaption {
							color: #555555;
							font-size: 15px;
							text-align: center;
						}

						.has-pale-pink-color {
							color: #f78da7;
						}

						.has-vivid-red-color {
							color: #cf2e2e;
						}

						.has-luminous-vivid-orange-color {
							color: #ff6900;
						}

						.has-luminous-vivid-amber-color {
							color: #fcb900;
						}

						.has-light-green-cyan-color {
							color: #7bdcb5;
						}

						.has-vivid-green-cyan-color {
							color: #00d084;
						}

						.has-pale-cyan-blue-color {
							color: #8ed1fc;
						}

						.has-vivid-cyan-blue-color {
							color: #0693e3;
						}

						.has-vivid-purple-color {
							color: #9b51e0;
						}

						.has-white-color {
							color: #fff;
						}

						.has-very-light-gray-color {
							color: #eee;
						}

						:root .editor-styles-wrapper .has-cyan-bluish-gray-color {
							color: #abb8c3;
						}

						:root .editor-styles-wrapper .has-very-dark-gray-color {
							color: #313131;
						}

						:root .editor-styles-wrapper .has-black-color {
							color: #000;
						}
					}
				}
				.list-btn-box {
					max-width: 157px;
					width: 100%;
					margin: 80px auto 0 auto;
					.list-btn {
						border-radius: 66px;
						border: 1px solid #eee;
						background: #fff;
						display: inline-flex;
						align-items: center;
						justify-content: center;
						gap: 8px;
						width: 100%;
						height: 54px;
						font-size: 14px;
						font-style: normal;
						font-weight: 600;
						line-height: 150%;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							opacity: 0.8;
						}
					}
				}
			}
		}
		.right {
			margin-top: 100px;
			padding-left: 40px;
			max-width: 340px;
			width: 100%;
			.top-wrap {
				margin-bottom: 96px;
			}
			.top-box {
				display: flex;
				align-items: center;
				gap: 21px;
				.imgbox {
					display: flex;
					align-items: end;
					.topimg {
						width: 88px;
						height: 88px;
						background-image: url(/images/list-icon02.png);
						background-position: center;
						background-repeat: no-repeat;
						background-size: cover;
						border-radius: 50%;
					}
					.user {
						width: 43px;
						height: 42px;
						background-image: url(/images/userimg.png);
						background-position: center;
						background-repeat: no-repeat;
						background-size: cover;
						border-radius: 50%;
						border: 2px solid #fff;
						margin-left: -25px;
					}
				}
				.text-box {
					h3 {
						font-size: 18px;
						font-weight: 700;
					}
					.total {
						color: #666;
						margin-top: 8px;
						font-size: 16px;
						font-weight: 400;
						line-height: normal;
					}
					.user-info {
						display: flex;
						align-items: center;
						gap: 22px;
						margin-top: 8px;
						p {
							font-size: 16px;
							font-weight: 400;
							position: relative;
							&:after {
								position: absolute;
								content: '';
								top: 50%;
								transform: translateY(-50%);
								right: -11px;
								width: 2px;
								height: 2px;
								background-color: #888;
								border-radius: 50%;
							}
						}
						span {
							color: #888;
							font-family: Pretendard;
							font-size: 16px;
							font-weight: 500;
							line-height: normal;
						}
					}
				}
			}
			.content {
				margin-top: 30px;
				border-radius: 10px;
				background: rgba(0, 0, 0, 0.03);
				padding: 16px;
				p {
					font-size: 14px;
					font-weight: 400;
					line-height: 160%;
				}
			}

			.bulletin {
				/* margin-top: 96px; */
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-bottom: 30px;
					margin-left: -3px;
				}
				.bulletin-list {
					display: flex;
					align-items: center;
					gap: 20px;
					margin-top: 30px;
					margin-left: -3px;
					.photo {
						width: 88px;
						height: 88px;
						background-repeat: no-repeat;
						background-position: center !important;
						background-size: cover !important;
						border-radius: 12px;
						background: #d9d9d9;
					}
					.text-box {
						ul {
							display: flex;
							gap: 11px;
							li {
								color: #e99210;
								font-size: 13px;
								font-weight: 300;
								line-height: normal;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
							}
						}
						h4 {
							/* max-width: 192px; */
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							font-size: 16px;
							margin-top: 8px;
							font-weight: 700;
							line-height: 140%;
						}
						.date-box {
							display: flex;
							align-items: center;
							gap: 24px;
							margin-top: 10px;
							.user-box {
								display: flex;
								gap: 6px;
								.user {
									width: 16px;
									height: 16px;
									border-radius: 50%;
									background-size: cover;
									background-position: center;
									background-repeat: no-repeat;
								}
								p {
									font-size: 13px;
									font-weight: 400;
									line-height: 140%;
									position: relative;
									&:after {
										position: absolute;
										content: '';
										width: 1px;
										height: 12px;
										background-color: #eee;
										top: 50%;
										transform: translateY(-50%);
										right: -11px;
									}
								}
							}
							span {
								color: #999;
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
							}
						}
					}
				}
			}
			.tag {
				margin-top: 103px;
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-left: -3px;
				}
				ul {
					margin-top: 26px;
					display: flex;
					flex-wrap: wrap;
					gap: 12px 10px;
					li {
						padding: 7px 18px;
						border-radius: 50px;
						border: 1px solid #eee;
						background: #fff;
						font-size: 16px;
						font-weight: 300;
						display: inline-block;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							background: #f7f7f7;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.flex-wrapper {
			display: flex;
			.left {
				padding-right: 30px;
				.article-wrap {
					margin-top: 98px;
					margin-left: 2px;
					.article-card {
						gap: 20px;
						.article-img {
							width: 180px;
							padding-bottom: 70%;
						}
						.text-box {
							h3 {
								margin-top: 7px;
								font-size: 18px;
							}
							.flex {
								p {
									font-size: 12px;
									margin-right: 10px;
								}
								.name {
									font-size: 12px;
									margin-right: 10px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
					.share-box {
						.left {
							display: flex;
							gap: 14px;
							border-right: none;
						}
						.right {
							margin-top: 0;
							padding-left: 0px;
							.flex {
								white-space: nowrap;
								p {
									font-size: 13px;
								}
								.name {
									font-size: 13px;
								}
								.date {
									font-size: 13px;
								}
							}
						}
					}
				}
			}
			.right {
				padding-left: 30px;
				max-width: 280px;
			}
		}
	}

	@media screen and (max-width: 768px) {
		margin-top: 0;
		padding: 0;

		.flex-wrapper {
			flex-wrap: wrap;
			.left {
				max-width: 100%;
				border-right: none;
				padding: 0;
				.article-wrap {
					margin-top: 50px;
					margin-left: 2px;
					.tag-box {
						gap: 14px;
						padding: 0 20px;
						li {
							font-size: 14px;
							font-weight: 300;
						}
					}
					.title {
						font-size: 24px;
						line-height: 160%;
						margin-top: 10px;
						margin-bottom: 6px;
						padding: 0 20px;
					}
					.share-box {
						gap: 16px;
						flex-direction: column-reverse;
						padding: 0 20px;
						.left {
							padding: 0;
							a {
								width: 32px;
								height: 32px;
								border-radius: 10px;
								img {
									width: 24px;
								}
							}
						}
						.right {
							.flex {
								margin-top: 9px;
								justify-content: flex-start;
								p {
									font-size: 15px;
								}
								.name {
									font-size: 15px;
								}
								.date {
									font-size: 15px;
								}
							}
						}
					}
					.flex-wrap {
						flex-wrap: wrap;
						.left-box {
							width: 100%;
							.article-box {
								margin-top: 22px;
								.article {
									border-radius: 0;
									/* padding-bottom: 65%; */
								}
								.content {
									margin-top: 24px;
									padding: 0 20px;

									iframe {
										width: 100%;
										height: 270px;
									}

									p {
										font-size: 14px;
										margin-bottom: 10px;
									}
								}
							}
							.mo-top-wrap {
								display: block;
								margin-top: 30px;
								padding: 0 20px;
								.mo-top-box {
									display: flex;
									align-items: center;
									gap: 24px;
									.imgbox {
										display: flex;
										align-items: end;
										.topimg {
											width: 68px;
											height: 68px;
											background-image: url(/images/list-icon02.png);
											background-position: center;
											background-repeat: no-repeat;
											background-size: cover;
											border-radius: 50%;
										}
										.user {
											width: 35px;
											height: 35px;
											background-image: url(/images/userimg.png);
											background-position: center;
											background-repeat: no-repeat;
											background-size: cover;
											border-radius: 50%;
											border: 2px solid #fff;
											margin-left: -25px;
										}
									}
									.text-box {
										h3 {
											font-size: 18px;
											font-weight: 700;
										}
										.user-info {
											display: flex;
											align-items: center;
											gap: 18px;
											margin-top: 6px;
											p {
												font-size: 13px;
												font-weight: 500;
												position: relative;
												&:after {
													position: absolute;
													content: '';
													top: 50%;
													transform: translateY(-50%);
													right: -9px;
													width: 2px;
													height: 2px;
													background-color: #888;
													border-radius: 50%;
												}
											}
											span {
												color: #888;
												font-family: Pretendard;
												font-size: 13px;
												font-weight: 500;
												line-height: normal;
											}
										}
									}
								}
								.mo-content {
									display: block;
									margin-top: 26px;
									border-radius: 10px;
									background: rgba(0, 0, 0, 0.03);
									padding: 12px;
									p {
										font-size: 12px;
										font-weight: 400;
										line-height: 160%;
									}
								}
							}
							.list-btn-box {
								max-width: 133px;
								margin: 40px auto 0 auto;
								.list-btn {
									border-radius: 12px;
									height: 42px;
								}
							}
						}
					}
					.card-box {
						display: block;
						border-bottom: 1px solid #eee;
						padding-bottom: 30px;
						margin-bottom: 30px;
						&:last-child {
							padding-bottom: 0;
							margin-bottom: 0;
						}
					}
					.article-card {
						flex-wrap: wrap;
						gap: 20px;
						.article-img {
							width: 100%;
							height: 0;
							padding-bottom: 55.4%;
							border-radius: 16px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}

						h3 {
							margin-top: 6px;
							font-size: 18px;
						}
						.content {
							margin-top: 8px;
							font-size: 13px;
						}
						.flex {
							.name {
								font-size: 13px;
							}
							.date {
								font-size: 13px;
							}
						}
					}
					.right-box {
						display: none;
					}
				}
			}
			.mo-banner-wrap {
				width: 100%;
				display: block;
				padding: 0 20px;
				.mo-banner {
					padding: 22px 24px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					border-radius: 8px;
					p {
						font-size: 18px;
						font-weight: 600;
						line-height: 140%;
						max-width: 185px;
						word-break: keep-all;
						margin-bottom: 12px;
					}
					span {
						display: flex;
						align-items: center;
						gap: 6px;
						font-size: 12px;
						font-weight: 400;
						line-height: normal;
						img {
							width: 4px;
							height: 8px;
						}
					}
				}
				.line {
					border-bottom: 8px solid #f7f7f7;
					margin: 60px -20px 0 -20px;
				}
			}
			.right {
				margin-top: 0px;
				padding-left: 0;
				max-width: 100%;
				.top-box {
					display: none;
				}
				.content {
					display: none;
				}

				.bulletin {
					margin-top: 60px;
					margin-bottom: 60px;
					padding: 0 20px;
					h3 {
						font-size: 18px;
						font-weight: 700;
						margin-bottom: 20px;
						margin-left: -1px;
					}
					.bulletin-list {
						gap: 18px;
						margin-top: 20px;
						.text-box {
							ul {
								gap: 12px;
							}
							.date-box {
								p {
									font-size: 13px;
									font-weight: 300;
								}
								span {
									font-size: 13px;
									font-weight: 300;
								}
							}
						}
					}
				}
				.tag {
					margin-top: 60px;
					padding: 0 20px;
					h3 {
						margin-left: 8px;
					}
					ul {
						margin-top: 20px;
						li {
							padding: 7px 18px;
						}
					}
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	margin-top: 100px;
	.banner {
		width: 100%;
		background: #d9d9d9;
		padding: 60px 60px 54px 60px;
		border-radius: 18px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		p {
			font-size: 30px;
			font-weight: 600;
			margin-bottom: 23px;
		}
		span {
			font-size: 18px;
			font-weight: 400;
			display: flex;
			align-items: center;
			gap: 10px;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const ArticleWRapper = styled.div`
	margin-top: 100px;
	h2 {
		font-size: 30px;
		font-weight: 700;
		line-height: 140%;
		margin-bottom: 38px;
	}
	.article-wrap {
		.banner {
			width: 100%;
			height: 0;
			padding-bottom: 64%;
			border-radius: 18px;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				opacity: 0.8;
			}
		}
		.content {
			margin-top: 20px;
			margin-left: 10px;
			ul {
				display: flex;
				gap: 16px;
				li {
					color: #e99210;
					font-size: 13px;
					font-weight: 400;
					line-height: 140%;
				}
			}
			.title {
				margin-top: 6px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				text-overflow: ellipsis;
				font-size: 28px;
				font-weight: 700;
				line-height: 150%;
				margin-bottom: 0;
			}
			.cont {
				margin-top: 9px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				text-overflow: ellipsis;
				font-size: 14px;
				font-weight: 400;
				line-height: 160%;
				color: #888;
			}
			.flex {
				display: flex;
				align-items: center;
				margin-top: 12px;
				.user-box {
					display: flex;
					.user {
						width: 16px;
						height: 16px;
						border-radius: 50%;
						background-repeat: no-repeat;
						background-size: cover;
						background-position: center;
						margin-right: 6px;
						border: 0.5px solid #eee;

						&:nth-child(2) {
							position: relative;
							left: -10px;
						}
						&:nth-child(3) {
							position: relative;
							left: -20px;
						}
					}
				}
				p {
					font-size: 13px;
					font-weight: 400;
					line-height: 140%;
					margin-right: 27px;
				}
				.name {
					font-size: 13px;
					color: #000;
					font-weight: 400;
					line-height: 140%;
					margin-right: 27px;
					position: relative;
					display: flex;
					align-items: center;
					gap: 4px;
					img {
						width: 16px;
					}
					&::after {
						position: absolute;
						content: '';
						width: 1px;
						height: 12px;
						background-color: #eee;
						left: -13px;
						top: 50%;
						transform: translateY(-50%);
					}
				}
				.date {
					color: #000;
					font-size: 13px;
					font-weight: 400;
					line-height: 140%;
					position: relative;
					&::before {
						position: absolute;
						content: '';
						width: 1px;
						height: 12px;
						background-color: #eee;
						left: -13px;
						top: 50%;
						transform: translateY(-50%);
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.article-wrap {
			.content {
				margin-top: 20px;
				margin-left: 10px;
				.title {
					font-size: 24px;
				}
				.flex {
					p {
						font-size: 13px;
						margin-right: 10px;
					}
					.name {
						font-size: 13px;
						margin-right: 10px;
						&::after {
							right: -5px;
						}
						&::before {
							left: -5px;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const MoArticleWRapper = styled.div`
	display: none;

	@media screen and (max-width: 768px) {
		display: block;
		margin-top: 60px;
		padding: 0 0 0 20px;
		h2 {
			font-size: 18px;
			font-weight: 700;
			line-height: 140%;
			margin-bottom: 20px;
			margin-left: 10px;
		}
		.article-wrap {
			.banner {
				width: 100%;
				height: 0;
				padding-bottom: 55%;
				border-radius: 16px;
				background-size: cover;
				background-position: center;
				background-repeat: no-repeat;
				cursor: pointer;
				transition: all 0.3s;
				&:hover {
					opacity: 0.8;
				}
			}
			.content-box {
				margin-top: 20px;
				padding-left: 10px;
				ul {
					display: flex;
					gap: 12px;
					li {
						color: #e99210;
						font-size: 13px;
						font-weight: 300;
						line-height: normal;
					}
				}
				.title {
					margin-top: 6px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					text-overflow: ellipsis;
					font-size: 18px;
					font-weight: 700;
					line-height: 140%;
					margin-bottom: 0;
					margin-left: 0;
				}
				.cont {
					margin-top: 8px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					text-overflow: ellipsis;
					font-size: 13px;
					font-weight: 300;
					line-height: 140%;
					color: #888;
				}
				.flex {
					display: flex;
					align-items: center;
					margin-top: 14px;
					.user-box {
						display: flex;

						.user {
							width: 16px;
							height: 16px;
							border-radius: 50%;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
							margin-right: 6px;
							border: 0.5px solid #eee;
							&:nth-child(2) {
								position: relative;
								left: -10px;
							}
							&:nth-child(3) {
								position: relative;
								left: -20px;
							}
						}
					}
					p {
						font-size: 12px;
						color: #000;
						font-weight: 400;
						line-height: 140%;
						margin-right: 27px;
					}
					.name {
						font-size: 12px;
						color: #000;
						font-weight: 400;
						line-height: 140%;
						margin-right: 27px;
						position: relative;
						display: flex;
						align-items: center;
						gap: 4px;
						img {
							width: 16px;
						}
						&::after {
							position: absolute;
							content: '';
							width: 1px;
							height: 12px;
							background-color: #eee;
							right: -11px;
							top: 50%;
							transform: translateY(-50%);
						}
					}
					.date {
						font-size: 12px;
						font-weight: 400;
						line-height: 140%;
						margin-right: 0;
					}
				}
			}
		}
	}
`;
